var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app d-flex flex-column",attrs:{"id":"app"}},[_c('router-view'),_c('mobile-checker'),_c('all-modals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }